import script from "./LaputaSite.vue?vue&type=script&setup=true&lang=js"
export * from "./LaputaSite.vue?vue&type=script&setup=true&lang=js"

import "./LaputaSite.vue?vue&type=style&index=0&id=94f6e34e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94f6e34e"]])

export default __exports__